/**
 * A short, decorative confetti burst for the Final Results screen —
 * accompanies the winner banner (src/ui/views/summary.ts). Plain DOM + CSS
 * animation, no dependency (see CLAUDE.md's "no runtime dependencies unless
 * there's a strong reason" convention).
 *
 * Skips entirely when the viewer has asked for reduced motion, same call as
 * the banner it accompanies — this is pure decoration with nothing
 * informational lost by not showing it.
 */

const COLORS = ['#e0b400', '#d94f4f', '#3a8fd9', '#4caf6b', '#c15fc1', '#ff8a3d'];
const PIECE_COUNT = 60;
const DURATION_MS = 3200;

export function launchConfetti(): void {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const layer = document.createElement('div');
  layer.className = 'confetti-layer';

  for (let i = 0; i < PIECE_COUNT; i++) {
    const piece = document.createElement('span');
    piece.className = 'confetti-piece';
    piece.style.left = `${Math.random() * 100}%`;
    piece.style.background = COLORS[i % COLORS.length]!;
    piece.style.setProperty('--fall-duration', `${2.4 + Math.random() * 1.6}s`);
    piece.style.setProperty('--fall-delay', `${Math.random() * 0.4}s`);
    piece.style.setProperty('--drift', `${(Math.random() - 0.5) * 160}px`);
    piece.style.setProperty('--rotate', `${360 + Math.random() * 360}deg`);
    layer.appendChild(piece);
  }

  document.body.appendChild(layer);
  // Longest possible piece animation (fall-duration max + fall-delay max)
  // plus a little slack, so nothing gets yanked away mid-fall.
  setTimeout(() => layer.remove(), DURATION_MS + 600);
}
